(function () {
  'use strict';

  const sidebar = document.getElementById('mobile-sidebar');
  if (!sidebar) return;

  const panel = sidebar.querySelector('.mobile-sidebar__panel');
  const overlay = sidebar.querySelector('.mobile-sidebar__overlay');
  const closeBtn = sidebar.querySelector('.mobile-sidebar__close');
  const mainLevel = sidebar.querySelector('.mobile-sidebar__level[data-level="1"]');
  const hamburger = document.querySelector('.site-header__hamburger');

  // iOS Safari ignores `overflow: hidden` on <body> for touch scrolling — the
  // page behind the open menu still scrolls when the user swipes. Workaround:
  // freeze the body with position: fixed + top: -scrollY, then restore on close.
  let savedScrollY = 0;
  let returnFocus = null;

  function open() {
    returnFocus = document.activeElement;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    sidebar.classList.add('mobile-sidebar--open');
    sidebar.setAttribute('aria-hidden', 'false');
    sidebar.removeAttribute('inert');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    closeBtn.focus();
  }

  function close() {
    // Close transient language UI, while preserving the current navigation level.
    sidebar.querySelectorAll('.casify-lang.is-open').forEach(function (el) {
      el.classList.remove('is-open');
      el.querySelector('.casify-lang__toggle').setAttribute('aria-expanded', 'false');
      var languagePanel = el.querySelector('.casify-lang__panel');
      languagePanel.setAttribute('inert', '');
      languagePanel.setAttribute('aria-hidden', 'true');
    });
    sidebar.classList.remove('mobile-sidebar--open');
    sidebar.setAttribute('aria-hidden', 'true');
    sidebar.setAttribute('inert', '');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');

    // `html { scroll-behavior: smooth }` (base.css) would otherwise animate the
    // scroll restore below — the page visibly glides from top back to where the
    // user was. Disable smooth scrolling for the synchronous restore, then revert.
    var root = document.documentElement;
    var prevBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';

    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.left     = '';
    document.body.style.right    = '';
    document.body.style.width    = '';
    window.scrollTo(0, savedScrollY);

    root.style.scrollBehavior = prevBehavior;
    if (returnFocus && returnFocus.focus) returnFocus.focus();
    returnFocus = null;
    // Intentionally do NOT call closeAllSubPanels() — preserves the active panel
    // so reopening returns to the same view (memory behavior, like Mous/Casetify).
  }

  function openSubPanel(name) {
    closeAllSubPanels();
    const target = sidebar.querySelector('[data-panel="' + name + '"]');
    if (!target) return;
    target.classList.add('is-active');
    target.setAttribute('aria-hidden', 'false');
    target.removeAttribute('inert');
    if (mainLevel) {
      mainLevel.setAttribute('aria-hidden', 'true');
      mainLevel.setAttribute('inert', '');
    }
    panel.classList.add('has-sub-active');
    // Scroll sub-panel to top
    target.scrollTop = 0;
  }

  function closeAllSubPanels() {
    sidebar.querySelectorAll('.mobile-sidebar__level--sub').forEach(function (el) {
      el.classList.remove('is-active');
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('inert', '');
    });
    if (mainLevel) {
      mainLevel.setAttribute('aria-hidden', 'false');
      mainLevel.removeAttribute('inert');
    }
    panel.classList.remove('has-sub-active');
  }

  // Open via hamburger in header
  document.addEventListener('sidebar:open', open);

  // Close via overlay
  overlay.addEventListener('click', close);

  // Close via X button
  closeBtn.addEventListener('click', close);

  // Open sub-panel buttons
  sidebar.querySelectorAll('[data-open-panel]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openSubPanel(btn.dataset.openPanel);
    });
  });

  // Back buttons
  sidebar.querySelectorAll('[data-close-panel]').forEach(function (btn) {
    btn.addEventListener('click', closeAllSubPanels);
  });

  // ESC key closes sidebar
  document.addEventListener('keydown', function (e) {
    if (!sidebar.classList.contains('mobile-sidebar--open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(sidebar.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (el) {
      return el.offsetParent !== null && !el.closest('[inert], [aria-hidden="true"]');
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Bottom "Winkelmandje" button → close sidebar, open the cart drawer
  // (instead of navigating to /cart). Uses the cart:open custom event that
  // section-cart-drawer.js listens for.
  var sidebarCartTrigger = document.getElementById('mobile-sidebar-cart-trigger');
  if (sidebarCartTrigger) {
    sidebarCartTrigger.addEventListener('click', function () {
      close();
      // Small delay so the sidebar close animation reads cleanly before the
      // drawer slides in — otherwise both happen on the same frame.
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('cart:open'));
      }, 60);
    });
  }
})();
